import EfSpec from '@elem/ui/ef-spec';
import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale = 'eu' } = getLocal();
    const IS_UK_SITE = locale === 'uk';

    const { t } = useLang('theProduct.PowerARange');
    return (
        <div className={styles.TheComp}>
            <EfSection
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                h5={
                    IS_UK_SITE
                        ? 'https://websiteoss.ecoflow.com/upload/image/1741155353152/6_1.png'
                        : 'https://websiteoss.ecoflow.com/upload/image/1741080516672/par-h5-1.jpg'
                }
                pad={
                    IS_UK_SITE
                        ? 'https://websiteoss.ecoflow.com/upload/image/1741155365512/6_1.png'
                        : 'https://websiteoss.ecoflow.com/upload/image/1741080516843/par-pad-1.jpg'
                }
                pc={
                    IS_UK_SITE
                        ? 'https://websiteoss.ecoflow.com/upload/image/1741155378725/6_1.png'
                        : 'https://websiteoss.ecoflow.com/upload/image/1741080517019/par-pc-1.jpg'
                }
            />
            <EfSpec />
        </div>
    );
}
